import * as React from 'react'
import { t } from 'ttag'
import { ActivityProgress, GoalWithProgress, ProgressType, ServiceProvider } from '../../services/api.types'
import './YumUserActivity.scss'
import { Grid } from '@material-ui/core'
import { YumUserProgress } from '../YumUserProgress/YumUserProgress'
import { isNative } from '../../common/helpers/isNative'
import YumUserProgressCelebration from '../YumUserProgressCelebration/YumUserProgressCelebration'
import { openActivityIndexArticle } from '../../common/helpers/routeHelpers'
import Typography from '@material-ui/core/Typography'
import YumUserProgressWrapper from '../YumUserProgress/YumUserProgressWrapper'
import { isActivityIndexType, isCollectiveType, isPersistenceType } from '../../common/helpers/challenges'
import YumCustomEntryWrapper from '../YumCustomEntry/YumCustomEntryWrapper'
import YumLogActivityWrapper from '../YumLogActivity/YumLogActivityWrapper'

export interface IYumUserActivityProps {
  goalDto: GoalWithProgress
  userProgress: ActivityProgress
  serviceProvider: ServiceProvider
  isUser: boolean
}

export class YumUserActivity extends React.PureComponent<IYumUserActivityProps> {
  render() {
    const { goalDto, userProgress, isUser } = this.props
    const {
      progressType,
      participating,
      startDate,
      endDate,
      activityFormulaTarget,
      collectiveGoal,
      collectivePercentage,
      collectiveTotal,
      ownerUserId,
      participantsCount,
      dailyPersistenceGoal,
      customType,
      manualEntryEnabled,
    } = goalDto

    if (
      isUser &&
      (!userProgress ||
        (!userProgress.stepsGoal && !userProgress.persistenceGoal && progressType !== ProgressType.COLLECTIVE_CUSTOM))
    ) {
      if (!participating || startDate > new Date().getTime() || endDate < new Date().getTime()) {
        return null
      }
      return (
        <div className="user-activity user-activity--is-empty">
          {t`We are synchronizing your data. This usually takes a couple of minutes.`}
        </div>
      )
    }

    const isActivityIndexChallenge = isActivityIndexType(progressType)
    const isCollectiveChallenge = isCollectiveType(progressType)
    const isPersistenceChallenge = isPersistenceType(progressType)
    return (
      <>
        <div className="user-activity__helper">
          <Grid container={true} justifyContent="space-between" alignContent="center" wrap="nowrap">
            {isUser || isCollectiveChallenge || isPersistenceChallenge ? (
              <>
                <Grid item={true} style={{ whiteSpace: 'nowrap' }}>
                  <Typography variant="caption">{t`Your progress`}</Typography>
                </Grid>
                {/*<Grid item={true}>
                  {goalDto.progressType !== ProgressType.CUSTOM && goalDto.manualEntryEnabled && (
                    <YumLogActivityWrapper goal={goalDto}></YumLogActivityWrapper>
                  )}
                </Grid>*/}
              </>
            ) : (
              ''
            )}
            {isActivityIndexChallenge && isUser && (
              <Grid item={true} className={'text-right'}>
                <a
                  className={'link'}
                  href={undefined}
                  onClick={openActivityIndexArticle}
                >{t`What's activity index?`}</a>
              </Grid>
            )}
            {/*<Grid item={true} className={userProgress.lastSync ? 'text-right' : ''}>
              <YumLastSync lastSync={userProgress.lastSync} />
            </Grid>*/}
          </Grid>
          <YumUserProgressWrapper
            className="user-activity"
            activityProgress={userProgress}
            progressType={progressType}
            activityFormulaTarget={activityFormulaTarget}
            collectiveGoal={collectiveGoal}
            collectivePercentage={collectivePercentage}
            collectiveTotal={collectiveTotal}
            ownerUserId={ownerUserId}
            participantsCount={participantsCount}
            dailyPersistenceGoal={dailyPersistenceGoal || 0}
            startDate={startDate}
            endDate={endDate}
            customType={customType}
          />
        </div>
        {isNative() && isUser ? (
          <YumUserProgressCelebration
            activityProgress={userProgress}
            progressType={progressType}
            manualEntryEnabled={manualEntryEnabled}
          />
        ) : (
          ''
        )}
      </>
    )
  }
}
